<template>
  <div class="row m-0 form-container">
    <nk-input ref="input" :class="[getSizeClass(this.settings.inputSize), 'p-0']" v-model="localData[settings.resolveNames[0]]" @update:modelValue="valueChanged" :options="settings.inputOptions" :tabindex="tabindex" :disabled="isDisabled ? true : null"></nk-input>
    <nk-dropdown ref="dropdown" :class="[getSizeClass(this.settings.dropdownSize), 'p-0']" @update:modelValue="dropdownChanged" :options="settings.dropdownOptions" :data="settings.dropdownItems" v-model="localData[settings.resolveNames[1]]" :tabindex="tabindex !== 0 ? tabindex + 1 : tabindex" :disabled="isDisabled ? true : null"></nk-dropdown>
  </div>
</template>

<script>
  import $ from 'jquery'
  import $sc from '~/plugins/shortcut.collection.js'
  import _ from 'lodash'

  export default {
    props: {
      options: { type: Object },
      modelValue: { type: [Object, String, Number] },
      disabled: { type: Boolean },
      tabindex: { type: [String, Number], default: 100 },
    },
    emits: ['update:modelValue'],

    watch: {
      options: {
        deep: true,
        immediate: true,
        handler(val) {
          this.settings = _.merge(this.settings, val)
        },
      },
      modelValue: {
        handler(val) {
          this.localData.value = val[this.settings.resolveNames[0]]
          this.localData.selectedOption = val[this.settings.resolveNames[1]]
        },
      },
    },
    mounted() {
      this.settings = _.merge(this.settings, this.options)

      if (this.settings.readValueFromOptions) {
        if (typeof this.settings.value === 'function') {
          this.localData = this.settings.value()
        }
        else
          this.localData = _.merge(this.localData, this.settings.value)
      } else {
        this.localData = _.merge(this.localData, this.modelValue)
      }

      if (!this.localData[this.settings.resolveNames[0]] && this.settings.defaultValue !== undefined) {
        this.localData[this.settings.resolveNames[0]] = this.settings.defaultValue
      }
      if (!this.localData[this.settings.resolveNames[1]] && this.settings.defaultSelectedOption !== undefined) {
        this.localData[this.settings.resolveNames[1]] = this.settings.defaultSelectedOption
      }
    },
    data() {
      return {
        localData: {
          value: '',
          selectedOption: null
        },
        settings: {
          readValueFromOptions: false,
          disabled: false,
          inputSize: { sm: 6 },
          dropdownSize: { sm: 6 },
          defaultValue: '',
          defaultSelectedOption: null,
          dropdownItems: [], // Array of dropdown items
          inputOptions: {
            mode: 'float'
          },
          dropdownOptions: {
            selectorWidth: '120px',
          },
          resolveNames: ['value', 'selectedOption'],
          onChangeHandlers: {
            input: () => { },
            dropdown: () => { }
          }
        }
      }
    },
    computed: {
      isDisabled() {
        return this.disabled || this.settings.disabled || false
      },
    },
    methods: {
      valueChanged() {
        let tmp = {}

        tmp[this.settings.resolveNames[0]] = this.localData[this.settings.resolveNames[0]]
        tmp[this.settings.resolveNames[1]] = this.localData[this.settings.resolveNames[1]]

        this.$emit('update:modelValue', tmp)
        this.settings.onChangeHandlers.input(tmp)
      },
      dropdownChanged(val) {
        let tmp = {}

        tmp[this.settings.resolveNames[0]] = this.localData[this.settings.resolveNames[0]]
        tmp[this.settings.resolveNames[1]] = val

        this.$emit('update:modelValue', tmp)
        this.settings.onChangeHandlers.dropdown(tmp)
      },
      getSizeClass(data) {
        var classes = []
        let sizes = data || { xs: 12 }

        for (var item in sizes) {
          classes.push(`col-${item}-${sizes[item]}`)
          if (item === 'xs')
            classes.push(`col-${sizes.xs}`)
        }

        if (classes.length === 0)
          classes.push('col-12')

        return classes
      },
      subscribeKeys() {
        this.$keyHandler.Subscribe({
          name: 'dropdown-input',
          keyCode: [13, 9],
          ctrlKey: false,
          altKey: false,
          when: 'before',
          el: this.$el,
          context: this,
          handler: function (sender, e) {
            e.preventDefault()
            if (this.$refs.dropdown && !$('input', $(this.$refs.dropdown.$el)).is(':focus')) {
              this.$refs.dropdown.$el.focus()
              return true
            }
            return false
          }
        }),
          this.$keyHandler.Subscribe({
            name: 'dropdown-input-right',
            shortcut: $sc.find('right', 'input'),
            el: this.$el,
            context: this,
            handler: function (sender, e) {
              e.preventDefault()
              if (this.$refs.dropdown && $('input', $(this.$refs.dropdown.$el)).is(':focus')) {
                this.$refs.input.$el.focus()
                return true
              }
              return false
            }
          }),
          this.$keyHandler.Subscribe({
            name: 'dropdown-input-left-arrow',
            shortcut: $sc.find('left', 'input'),
            el: this.$el,
            context: this,
            test: function () {
              return true
            },
            handler: function (sender, e) {
              if (this.$refs.input && $('input', $(this.$refs.input.$el)).is(':focus')) {
                this.$refs.dropdown.$el.focus()
                return true
              }
              return false
            },
          })
      }
    }
  }
</script>

<style></style>
